import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";

export const createAudit = async (readings, datasheetId) => {
  try {

    const userId = localStorage.getItem("id")
    // 1. Get last version
    const versionRes = await axiosWithToken.post(BASE_URL + `dynamic`, {
      query: `SELECT COALESCE(MAX(version), 0) AS lastVersion 
                FROM datasheetReadingsAudit
                WHERE datasheetId = ${datasheetId};`,
    });

    const lastVersion = versionRes?.data?.[0]?.lastVersion || 0;
    const nextVersion = lastVersion + 1;

    // 2. Add version to each reading
    const updatedReadings = readings.map((r) => ({
      ...r,
      version: nextVersion,
      createdby: userId,
    }));

    // 3. Save to Audit table
    await axiosWithToken.post(
      BASE_URL + `datasheetReadingsAudit/bulk`,
      updatedReadings
    );

    console.log("Readings added to audit");
  } catch (error) {
    console.error("Error creating audit:", error);
  }
};

export const getReadingAuditData = async (datasheetId) => {
  try {
    // 1. Fetch audit readings by datasheetId
    const auditRes = await axiosWithToken.post(BASE_URL + `dynamic`, {
      query: `SELECT * FROM datasheetReadingsAudit 
                WHERE datasheetId = ${datasheetId}
                ORDER BY version ASC, id ASC;`,
    });

    const auditRows = auditRes?.data || [];

    // 2. Group by version
    const versionMap = {};

    auditRows.forEach((row) => {
      if (!versionMap[row.version]) {
        versionMap[row.version] = [];
      }
      versionMap[row.version].push(row);
    });

    // 3. Convert to array of arrays
    const groupedArrays = Object.values(versionMap);

    console.log("Audit Grouped Data:", groupedArrays);

    // return groupedArrays;
  } catch (error) {
    console.error("Error fetching audit data:", error);
    return [];
  }
};
